import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "../Header/Header"
import { Layout as DefaultLayout } from '../../../../components/Layout/_Layout';
import { AuthorizedLayout } from "../../../../components/Auth/AuthorizedLayout";


export const Layout = () => {

    let location = useLocation();
    let navigate = useNavigate();

    // We should default to feed if the current route is "/connect"
    useEffect(() => {
        if (location?.pathname == "/connect") {
            navigate("/connect/events");
        }
    });

    return (
        <AuthorizedLayout>
            <DefaultLayout>
                <Header />
            </DefaultLayout>
        </AuthorizedLayout>
    )
}